export const CLEAR = 'zen/dashboardSettingsModal/CLEAR';
export const CLEAR_ERROR = 'zen/dashboardSettingsModal/CLEAR_ERROR';
export const CLEAR_ERRORS = 'zen/dashboardSettingsModal/CLEAR_ERRORS';
export const SET_ERROR = 'zen/dashboardSettingsModal/SET_ERROR';
export const SET_VALUE = 'zen/dashboardSettingsModal/SET_VALUE';
export const SET_FOCUS = 'zen/dashboardSettingsModal/SET_FOCUS';
export const FOCUSED = 'zen/dashboardSettingsModal/FOCUSED';
export const SAVE_STARTED = 'zen/dashboardSettingsModal/SAVE_STARTED';
export const SAVE_COMPLETED = 'zen/dashboardSettingsModal/SAVE_COMPLETED';

export const initialState = {
  errors: {
    title: null,
    profiles: null
  },
  isSaving: false,
  isSubmitted: false,
  shouldFocus: {
    title: true
  },
  values: {
    title: '',
    templateType: null,
    duplicateFrom: null,
    profiles: [],
    defaultProfile: null,
    defaultDateRange: null,
    customDateRangeStart: null,
    customDateRangeEnd: null,
    allProfilesSelected: true
  }
};

function reducer(state = initialState, { type, ...payload } = {}) {
  switch (type) {
    case CLEAR:
      return { ...initialState };
    case SET_VALUE:
      return {
        ...state,
        values: { ...state.values, [payload.field]: payload.value }
      };
    case SET_FOCUS:
      return {
        ...state,
        shouldFocus: { ...state.shouldFocus, [payload.field]: true }
      };
    case FOCUSED:
      return {
        ...state,
        shouldFocus: { ...state.shouldFocus, [payload.field]: false }
      };
    case SET_ERROR:
      return {
        ...state,
        isSubmitted: true,
        errors: { ...state.errors, [payload.field]: payload.value }
      };
    case CLEAR_ERROR:
      delete state.errors[payload.field];
      return {
        ...state,
        errors: { ...initialState.errors, ...state.errors }
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        errors: { ...initialState.errors }
      };
    case SAVE_STARTED:
      return {
        ...state,
        isSaving: true
      };
    case SAVE_COMPLETED:
      return {
        ...state,
        isSaving: false
      };
    default:
      return state;
  }
}

const clear = () => ({ type: CLEAR });
const clearError = (field) => ({ type: CLEAR_ERROR, field });
const clearErrors = () => ({ type: CLEAR_ERRORS });
const setValue = (field, value) => ({ type: SET_VALUE, field, value });
const setFocus = (field) => ({ type: SET_FOCUS, field });
const focused = (field) => ({ type: FOCUSED, field });
const setError = (field, value) => ({ type: SET_ERROR, field, value });
const saveStarted = () => ({ type: SAVE_STARTED });
const saveCompleted = () => ({ type: SAVE_COMPLETED });

export {
  clear,
  clearError,
  clearErrors,
  setValue,
  focused,
  setFocus,
  setError,
  saveStarted,
  saveCompleted
};
export default reducer;
